import React from "react";
import { ComponentTitle, PageTitleLastCol } from "../../custom-components";
import { CustomTable } from "../../series/StyledComponent";
import useScreenSizeHook from "../../utils/useScreenSizeHook";
import { Col, Row, Button } from "antd";
import { CloseCircleOutlined } from "@ant-design/icons";
import { useListingHook } from "./hooks/useListingHook";
import EditSegmentModal from "./EditSegmentModal";
import FilterSegmentsModal from "./FilterSegmentsModal";
import AmagiCloudPortRefreshDataButton from "./AmagiCloudPortRefreshButton";
import SyncPromosButton from "./SyncPromosButton";
import BulkSegmentationModal from "./BulkSegmentationModal";
import AddSegmentModal from "./AddSegmentModal";

const SegmentsListingComponent = () => {
	const { height } = useScreenSizeHook();
	

	const {
		getListingColumns,
		listingData,
		isLoading,
		pagination,
		handleTableChange,
		isEditModalOpen,
    	setIsEditModalOpen,
		isAddSegmentModalOpen,
		setIsAddSegmentModalOpen,
		editRecord,
		setEditRecord,
		handleEditSubmit,
		form,
		addSegmentForm,
		isFilteredData,
		setIsFilterModalOpen,
		isFilterModalOpen,
		clearFilter,
		filterForm,
		distributionPlatformData,
		handleFilterSubmit,
		bulkSegmentationForm,
		isBulkSegmentationModalOpen,
		setIsBulkSegmentationModalOpen,
		handleBulkSegmentation,
		handleAddSegmentSubmit,
		captionOrder,
		captionInfo,
		isCaptionInfoLoading,
		handleCaptionPlatformChange,
		moveCaptionLanguage
	} = useListingHook();

	return (
		<>
			<Row justify="space-between" align="middle">
				<Col>
					<ComponentTitle>Segments</ComponentTitle>
				</Col>
				<PageTitleLastCol>
					<Button onClick={() => {
						setIsBulkSegmentationModalOpen(true);
					}}>Segment Videos</Button>
					&nbsp;
					<AmagiCloudPortRefreshDataButton />
					<SyncPromosButton />
					<Button
						type="primary"
						onClick={() => {
							setIsAddSegmentModalOpen(true);
						}}> + Add Segment </Button>
						&nbsp;
						<Button onClick={() => setIsFilterModalOpen(true)}>Filters</Button>
						{isFilteredData && (
							<Button onClick={() => clearFilter()} icon={<CloseCircleOutlined />} />
						)}
				</PageTitleLastCol>
			</Row>
			<CustomTable
				onChange={handleTableChange}
				columns={getListingColumns()}
				dataSource={listingData}
				scroll={{ x: getListingColumns().length > 8 ? getListingColumns().length * 150 : undefined, y: height - 240 }}
				loading={isLoading}
				pagination={
					{
						...pagination,
						showTotal: (total, range) => `${range[0]}-${range[1]} of ${total} segments`,
					}
				}
			/>
			<EditSegmentModal
				form={form}
				visible={isEditModalOpen}
				onClose={() => {
					setEditRecord(null);
					setIsEditModalOpen(false);
				}
				}
				onSubmit={handleEditSubmit}
				initialValues={editRecord}
			/>
			<AddSegmentModal
				form={addSegmentForm}
				visible={isAddSegmentModalOpen}
				onClose={() => {
					setIsAddSegmentModalOpen(false);
					addSegmentForm.resetFields();
				}}
				onSubmit={handleAddSegmentSubmit}

			/>
			<FilterSegmentsModal
				form={filterForm}
				visible={isFilterModalOpen}
				onClose={() => setIsFilterModalOpen(false)}
				onOk={handleFilterSubmit}
			/>
			<BulkSegmentationModal
				form={bulkSegmentationForm}
				visible={isBulkSegmentationModalOpen}
				onOk={handleBulkSegmentation}
				onClose={() => setIsBulkSegmentationModalOpen(false)}
				distributionPlatformData={distributionPlatformData}
				captionOrder={captionOrder}
				captionInfo={captionInfo}
				isCaptionInfoLoading={isCaptionInfoLoading}
				onPlatformChange={handleCaptionPlatformChange}
				onMoveCaptionLanguage={moveCaptionLanguage}
			/>
		</>
	);
};

export default SegmentsListingComponent;
